import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-result-total',
    templateUrl: './result-total.component.html',
    styleUrls: ['./result-total.component.scss'],
    standalone: false
})
export class ResultTotalComponent implements OnInit {
  @Input() resultTotals: { alias: string, quantity: number }[] = [];

  constructor(
  ) { }

  ngOnInit() {

  }

  public trackByIndex(i: number) { return i; }

}
